import { Anchor } from "common/components/ui";
import React from "react";

export const CarrierEmailLink = <Anchor href="mailto:freight@deliverr.com">freight@deliverr.com</Anchor>;
